import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Loader2, Disc } from 'lucide-react';
import PublicLayout from '../../components/public/PublicLayout';
import AlbumCard from '../../components/public/AlbumCard';
import SEO from '../../components/SEO';

const LIMIT = 24;

function PublicAlbumListPage() {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchAlbums = useCallback(async (p, append = false) => {
    if (append) setLoadingMore(true);
    else setLoading(true);
    try {
      const res = await axios.get('/public/albums', { params: { page: p, limit: LIMIT } });
      const items = res.data.items || [];
      setAlbums((prev) => (append ? [...prev, ...items] : items));
      setPage(res.data.currentPage || p);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) {
      console.error('앨범 목록 로드 실패:', err);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  }, []);

  useEffect(() => {
    fetchAlbums(1);
  }, [fetchAlbums]);

  const handleLoadMore = () => {
    if (page < totalPages && !loadingMore) {
      fetchAlbums(page + 1, true);
    }
  };

  return (
    <PublicLayout>
      <SEO
        title="앨범"
        description="p!nk에서 유통중인 앨범 목록을 확인하세요."
        path="/albums"
      />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="text-xl sm:text-2xl font-bold text-white tracking-tight text-center mb-8">최신앨범</h1>

        {loading ? (
          <div className="flex items-center justify-center h-60 gap-3 text-slate-400">
            <Loader2 size={22} className="animate-spin" />
            <span>로딩 중...</span>
          </div>
        ) : albums.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 gap-3 text-slate-500">
            <Disc size={40} />
            <p>앨범이 없습니다.</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2 sm:gap-4">
              {albums.map((album) => (
                <AlbumCard key={album.id} album={album} />
              ))}
            </div>

            {page < totalPages && (
              <div className="flex justify-center mt-10">
                <button
                  onClick={handleLoadMore}
                  disabled={loadingMore}
                  className="flex items-center gap-2 px-6 py-2.5 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full text-slate-300 text-sm transition-colors">
                  {loadingMore ? (
                    <>
                      <Loader2 size={14} className="animate-spin" />
                      로딩 중...
                    </>
                  ) : (
                    '더 보기'
                  )}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </PublicLayout>
  );
}

export default PublicAlbumListPage;
